module.exports = __webpack_public_path__ + "static/img/vender-logo2.f8b2fc92.png";